import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../templates/stakeholders';
import {canUseDOM} from '../../../../../helpers/canUseDOM';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            subMode: this.getInitialSubMode(),
            isSegmentedCollapsed: canUseDOM ? window.innerWidth <= 960 : false
        };
    }

    updateWidth = () => {
        this.setState({isSegmentedCollapsed: window.innerWidth <= 960});
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    getInitialSubMode = () => {
        const category =
            this.props.match && this.props.match.params && this.props.match.params.category;

        if (category === 'owners' || category === 'reports' || category === 'special-info') {
            return category;
        }

        return 'reports';
    };

    componentDidUpdate(prevProps) {
        const prevCategory =
            prevProps.match && prevProps.match.params && prevProps.match.params.category;
        const currentCategory =
            this.props.match && this.props.match.params && this.props.match.params.category;

        if (
            prevCategory !== currentCategory &&
            (currentCategory === 'owners' ||
                currentCategory === 'reports' ||
                currentCategory === 'special-info')
        ) {
            this.setState({subMode: currentCategory});
        }
    }

    toggleSubMode = mode => {
        this.setState({subMode: mode});
        this.context.app.navigate(`/about/${mode}`);
    };

    static displayName = 'Stakeholders';

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
